import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'unh-button-old',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss']
})
export class ButtonComponent implements OnInit {
  @Input() translucid: boolean;

  constructor() {
    if (!this.translucid) {
      this.translucid = true;
    }
  }

  ngOnInit() {
  }

}
